import { styled } from 'linaria/react';
import { breakpoints } from 'media';

export const MainContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: flex-start;
	border-radius: 8px;
	background-color: #f5f4f1;
	padding: 20px;
	gap: 8px;
	margin-top: 24px;

	${breakpoints.only.mobile} {
		flex-direction: column;
		row-gap: 12px;
		column-gap: 0;
		padding: 12px;
	}
`;

export const InfoSection = styled.div`
	display: flex;
	align-items: flex-start;
	flex-grow: 1;
`;

export const TextWrapper = styled.div`
	width: 100%;
	padding: 4px;
	p + p {
		display: block;
		margin-top: 2px;
	}
`;

export const IconWrapper = styled.div`
	display: flex;
	padding: 4px;
`;

export const ButtonWrapper = styled.div`
	margin-left: auto;
`;
